export const NOTIFICATION_ROLE = 'status';
export const NOTIFICATION_ARIA_LIVE_LABEL = 'polite';
